import { ThunkAction } from "redux-thunk";
import { AppStateType, InferActionsTypes } from "../reducers/store";
import { ITbl, ITblFld } from "../entities/Tbl";
import { usersTbl } from "../constants/constants";
import { api } from "../api/api";
import { asyncForEach } from "./commonActions";
import { IOrder } from "../entities/Main";
import { apiSber } from "../api/apisber";

const actionPre = "USERS_";

export const LOAD_USERS = actionPre + "LOAD_USERS";
export const SET_USER_INFO = actionPre + "SET_USER_INFO";
export const ADD_SPR = actionPre + "ADD_SPR";
export const TOGGLE_IS_USERS_FETCHING = actionPre + "TOGGLE_IS_USERS_FETCHING";
export const SET_RESPONSE_MESSAGE = actionPre + "SET_RESPONSE_MESSAGE";
export const SET_ORDERS = actionPre + "SET_ORDERS";
export const SET_SUPPLIERS = actionPre + "SET_SUPPLIERS";
export const SET_SUPPLIER = actionPre + "SET_SUPPLIER";
export const SET_SHOPS = actionPre + "SET_SHOPS";
export const SET_SHOP = actionPre + "SET_SHOP";
export const SET_TAGS = actionPre + "SET_TAGS";
export const SET_VISIBLE_TRASH = actionPre + "SET_VISIBLE_TRASH";
export const SET_VISIBLE_CATALOG = actionPre + "SET_VISIBLE_CATALOG";
export const SET_VISIBLE_SHOPS = actionPre + "SET_VISIBLE_SHOPS";
export const SET_SELECT_FOOTER = actionPre + "SET_SELECT_FOOTER";
export const SET_TEXT_HEADER = actionPre + "SET_TEXT_HEADER";
export const SET_VISIBLE_BACK_BUTTON = actionPre + "SET_VISIBLE_BACK_BUTTON";
export const SET_COUNT_NEW_ORDER = actionPre + "SET_COUNT_NEW_ORDER";
export const SET_IS_PERSON = actionPre + "SET_IS_PERSON";

type ActionsTypes = InferActionsTypes<typeof usersActions>;
type ThunkType = ThunkAction<
  Promise<void>,
  AppStateType,
  unknown,
  ActionsTypes
>;

export const usersActions = {
  loadUsers: (users: ITbl) => ({ type: LOAD_USERS, users }),
  toggleIsUsersFetching: (isUsersFetching: boolean) =>
    ({
      type: TOGGLE_IS_USERS_FETCHING,
      isUsersFetching,
    } as const),
  addSpr: (spr: ITbl) => ({ type: ADD_SPR, spr }),
  setReduxOrders: (orders: Array<IOrder>) => ({ type: SET_ORDERS, orders }),
  setSuppliers: (suppliers: any) => ({ type: SET_SUPPLIERS, suppliers }),
  setSupplier: (supplier: any) => ({ type: SET_SUPPLIER, supplier }),
  setShops: (shops: any) => ({ type: SET_SHOPS, shops }),
  setShop: (shop: any) => ({ type: SET_SHOP, shop }),
  setTags: (tags: any) => ({ type: SET_TAGS, tags }),
  setVisibleTrash: (visible: boolean) => ({ type: SET_VISIBLE_TRASH, visible }),
  setVisibleCatalog: (visible: boolean) => ({
    type: SET_VISIBLE_CATALOG,
    visible,
  }),
  setVisibleShops: (visible: boolean) => ({ type: SET_VISIBLE_SHOPS, visible }),
  setSelectFooter: (text: string) => ({ type: SET_SELECT_FOOTER, text }),
  setTextHeader: (text: string) => ({ type: SET_TEXT_HEADER, text }),
  setBackButton: (visible: boolean) => ({
    type: SET_VISIBLE_BACK_BUTTON,
    visible,
  }),
  setCountNewOrder: (countNewOrder: number) => ({
    type: SET_COUNT_NEW_ORDER,
    countNewOrder,
  }),
  setIsPerson: (is_person: boolean) => ({ type: SET_IS_PERSON, is_person }),
  setUserInfo: (userInfo: string) => ({ type: SET_USER_INFO, userInfo }),
};

export const requestUsers = (): ThunkType => async (dispatch, getState) => {
  dispatch(usersActions.toggleIsUsersFetching(true));
  const responseTbl: ITbl | undefined = await api.getObjects(usersTbl);

  if (responseTbl !== undefined) {
    await asyncForEach(responseTbl!.fields!, async (field: ITblFld) => {
      if (
        field.type.startsWith("object") &&
        !getState().users.sprs.some((s) => s.code === field.obj_code)
      ) {
        const responseSpr: ITbl = await api.getObjects(field.obj_code!);
        dispatch(usersActions.addSpr(responseSpr));
      }
    });

    dispatch(usersActions.loadUsers(responseTbl!));
  }
  dispatch(usersActions.toggleIsUsersFetching(false));
};

export const setOrders =
  (orders: Array<IOrder>): ThunkType =>
  async (dispatch, getState) => {
    localStorage.setItem("orders", JSON.stringify(orders));
    dispatch(usersActions.setReduxOrders(orders));
  };

export const readOrders = (): ThunkType => async (dispatch, getState) => {
  if (localStorage.getItem("orders")) {
    const orders: any = JSON.parse(localStorage.getItem("orders")!);
    dispatch(usersActions.setReduxOrders(orders));
  }
};

export const getSuppliers = (cmd: string) => {
  return api.getSuppliers(cmd);
};

export const postSuppliers = (tbl: string, json: any) => {
  return api.postSuppliers(tbl, json);
};

export const getAdminSuppliers = (
  tbl: string,
  status: string,
  code_suppliers: string
) => {
  return api.getAdminSuppliers(tbl, status, code_suppliers);
};

export const getAdminObj = (tbl: string) => {
  return api.getAdminObj(tbl);
};

export const getAdminOptionsObj = (tbl: string, options: any) => {
  return api.getAdminOptionsObj(tbl, options);
};

export const getOrderUsers = (params: any) => {
  return api.getOrderUsers(params);
};

export const postOrderUser = (json: any) => {
  return api.postOrderUser(json);
};

export const getOrderUserOptions = (params: any) => {
  return api.getOrderUserOptions(params);
};

export const addAdminObj = (tbl: string, data: any) => {
  return api.addAdminObj(tbl, data);
};

export const editAdminObj = (tbl: string, data: any) => {
  return api.editAdminObj(tbl, data);
};

export const deleteAdminObj = (tbl: string, code: any) => {
  return api.deleteAdminObj(tbl, code);
};

export const getAnalyze = (json: any) => {
  return api.getAnalyze(json);
};

export const addEditAdmin = (tbl: string, json: any) => {
  return api.addEditAdmin(tbl, json);
};

export const deleteAdmin = (tbl: string, code: any) => {
  return api.deleteAdmin(tbl, code);
};

export const editAdmin = (tbl: string, data: any) => {
  return api.editAdmin(tbl, data);
};

export const saveFastOrder = (
  cmd: string,
  supplier_code: string,
  data: any,
  toCheckOrder: boolean,
  order_properties: any,
  comment: any
) => {
  return api.saveFastOrder(
    cmd,
    supplier_code,
    data,
    toCheckOrder,
    order_properties,
    comment
  );
};

export const getHistoryOrder = (
  cmd: string,
  supplier_code: string,
  rowSkip: number,
  rowCount: number
) => {
  return api.getHistoryOrder(cmd, supplier_code, rowSkip, rowCount);
};

export const checkSberStatus = (numberOrder: string) => {
  return apiSber.checkSberStatus(numberOrder);
};
